import z from "zod";

/**
 * ItemChecklistServicoSchema
 */

export const ItemChecklistServicoSchema = z.object({
  ordem: z.coerce.string().nonempty('Este campo deve ser preenchido!'),
  descricao: z.coerce.string().nonempty('Este campo deve ser preenchido!'),
  resumoItem: z.string().max(25, '').nullable().default(null),
  metodoVerificacao: z.string().max(2000, 'Informe no máximo 2.000 caracteres.').nullable().default(null),
  tolerancia: z.string().max(2000, 'Informe no máximo 2.000 caracteres.').nullable().default(null),
});

/**
 * ItemChecklistServicoForm
 */

export type ItemChecklistServicoForm = z.infer<typeof ItemChecklistServicoSchema>;
